import { render, staticRenderFns } from "./WebFooter.vue?vue&type=template&id=dad90232&scoped=true"
import script from "./WebFooter.vue?vue&type=script&lang=js"
export * from "./WebFooter.vue?vue&type=script&lang=js"
import style0 from "./WebFooter.vue?vue&type=style&index=0&id=dad90232&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad90232",
  null
  
)

export default component.exports